export function outgoingCash(report) {
    const cents = value => Math.round((Number(value) || 0) * 100);
    return (cents(report.openingCash) + cents(report.amountCash)
        + cents(report.addedChange) - cents(report.bankWithdrawal)) / 100;
}
